export enum UserType {
  POLICE = "POLICE",
  CUSTOMS = "CUSTOMS",
}
